import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getProfile } from '../api/userService';

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      profile: null,
      token: null,
      isLoggedIn: false,
      loading: false,
      error: null,
      
      login: (userData, token) => {
        set({ 
          user: userData, 
          token,
          isLoggedIn: true 
        });
        localStorage.setItem('authToken', token);
      },
      
      logout: () => {
        set({ 
          user: null, 
          token: null, 
          isLoggedIn: false 
        });
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        window.location.href = '/';
      },
      
      setUser: (userData) => set({ user: userData }),
      
      fetchProfile: async () => {
        try {
          set({ loading: true, error: null });
          const response = await getProfile();
          set({ profile: response.data, loading: false });
          return response.data;
        } catch (error) {
          set({ error: error.message, loading: false });
          throw error;
        }
      },
      
      clearProfile: () => set({ profile: null, error: null }),
      
      initialize: () => {
        const token = localStorage.getItem('authToken');
        const user = localStorage.getItem('authUser');
        if (token && user) {
          set({ 
            user: JSON.parse(user), 
            token,
            isLoggedIn: true 
          });
        }
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        profile: state.profile,
        token: state.token,
        isLoggedIn: state.isLoggedIn,
      }),
    }
  )
);

// Initialize the store when the app loads
if (typeof window !== 'undefined') {
  useAuthStore.getState().initialize();
}
